// extracted by mini-css-extract-plugin
export default {"content":"reassignModal_content__DC8bw","ddlContainer":"reassignModal_ddlContainer__juYp4"};